/**
 * @flow
 * @relayHash dcd06e43f047646802bfd26470dcc240
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ChangerComponent_orgs$ref = any;
export type ChangerOrgQueryVariables = {|
  name?: ?string
|};
export type ChangerOrgQueryResponse = {|
  +authorizedOrgs: $ReadOnlyArray<{|
    +$fragmentRefs: ChangerComponent_orgs$ref
  |}>
|};
export type ChangerOrgQuery = {|
  variables: ChangerOrgQueryVariables,
  response: ChangerOrgQueryResponse,
|};
*/


/*
query ChangerOrgQuery(
  $name: String
) {
  authorizedOrgs(name: $name) {
    ...ChangerComponent_orgs
    id
  }
}

fragment ChangerComponent_orgs on PicklistInterface {
  id
  name
  ...ListComponent_suggestions
}

fragment ListComponent_suggestions on PicklistInterface {
  id
  name
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ChangerOrgQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorizedOrgs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Org",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ChangerComponent_orgs",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ChangerOrgQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorizedOrgs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Org",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ChangerOrgQuery",
    "id": null,
    "text": "query ChangerOrgQuery(\n  $name: String\n) {\n  authorizedOrgs(name: $name) {\n    ...ChangerComponent_orgs\n    id\n  }\n}\n\nfragment ChangerComponent_orgs on PicklistInterface {\n  id\n  name\n  ...ListComponent_suggestions\n}\n\nfragment ListComponent_suggestions on PicklistInterface {\n  id\n  name\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0512b840bcabb2b578e7ff7960484864';
module.exports = node;
